import jwtDecode from 'jwt-decode'
import { logger } from './logger'

/**
 *
 * @param token Token string.
 * @param timeOffset Offset time to calculate if the token is valid. Defaults to 0.
 * @returns
 */
export const isTokenExpired = (
  token: string,
  timeOffset: number = 0,
): {
  valid: boolean
  expiresAt: number | null
  expiresAtIso: string | null
} | null => {
  try {
    const { exp }: { exp: number } = jwtDecode(token)

    if (!exp) {
      return {
        valid: false,
        expiresAt: null,
        expiresAtIso: null,
      }
    }

    return {
      valid:
        new Date(exp * 1000)?.getTime() - timeOffset >= new Date().getTime(),
      expiresAt: exp,
      expiresAtIso: new Date(exp * 1000).toISOString(),
    }
  } catch (error) {
    logger(error as string)
    return null
  }
}
